import { gsap } from 'gsap';

export function company_animation() {
	const root = document.querySelector('.c-company-nav-image');

	if (!root) {
		return;
	}

	const navItems = Array.from(
		root.querySelectorAll('.company-nav__item')
	);

	const visualItems = Array.from(
		root.querySelectorAll('.company-visual__image')
	);

	if (
		navItems.length === 0 ||
		visualItems.length === 0
	) {
		return;
	}

	let currentKey =
		root.querySelector('.company-nav__item.is-active')?.dataset.image ||
		navItems[0]?.dataset.image;

	let currentZIndex = 1;

	/**
	 * Initial
	 */
	gsap.set(visualItems, {
		opacity: 0,
		visibility: 'hidden',
		zIndex: 0,
		clipPath: 'inset(100% 0% 0% 0%)',
		rotate: -45,
		scale: 1.43,
	});

	visualItems.forEach((item) => {
		const img = item.querySelector('img');

		if (!img) {
			return;
		}

		gsap.set(img, {
			rotate: 45,
			scale: 0.7,
		});
	});

	/**
	 * First Active
	 */
	const firstVisual = visualItems.find(
		(item) => item.dataset.image === currentKey
	);

	if (firstVisual) {
		gsap.set(firstVisual, {
			opacity: 1,
			visibility: 'visible',
			zIndex: currentZIndex,
			clipPath: 'inset(0% 0% 0% 0%)',
		});

		const firstImg = firstVisual.querySelector('img');

		if (firstImg) {
			gsap.set(firstImg, {
				scale: 0.7,
			});
		}
	}

	/**
	 * Change Image
	 */
	const changeImage = (key) => {
		if (!key || currentKey === key) {
			return;
		}

		const nextVisual = visualItems.find(
			(item) => item.dataset.image === key
		);

		if (!nextVisual) {
			return;
		}

		const nextImage = nextVisual.querySelector('img');

		currentKey = key;
		currentZIndex++;

		/**
		 * Nav Active
		 */
		navItems.forEach((item) => {
			item.classList.toggle(
				'is-active',
				item.dataset.image === key
			);
		});

		/**
		 * Visual Active
		 */
		visualItems.forEach((item) => {
			item.classList.remove('is-active');
		});

		nextVisual.classList.add('is-active');

		/**
		 * Prepare
		 */
		gsap.set(nextVisual, {
			opacity: 1,
			visibility: 'visible',
			zIndex: currentZIndex,
			clipPath: 'inset(100% 0% 0% 0%)',
			rotate: -45,
			scale: 1.43,
		});

		if (nextImage) {
			gsap.set(nextImage, {
				rotate: 45,
				scale: 0.9,
			});
		}

		/**
		 * Animation
		 */
		gsap.to(nextVisual, {
			clipPath: 'inset(0% 0% 0% 0%)',
			duration: 0.75,
			ease: 'power3.inOut',
			overwrite: true,
		});

		if (nextImage) {
			gsap.to(nextImage, {
				scale: 0.7,
				duration: 0.75,
				ease: 'power3.inOut',
				overwrite: true,
			});
		}
	};

	/**
	 * Hover
	 */
	navItems.forEach((item) => {
		item.addEventListener('pointerenter', () => {
			changeImage(item.dataset.image);
		});
	});

	/**
	 * Keyboard Focus
	 */
	navItems.forEach((item) => {
		item.addEventListener('focusin', () => {
			changeImage(item.dataset.image);
		});
	});
}